module.exports = {
    apiKey: "AIzaSyB5oWaKQP4h8erUJYFeeVKgmb3Xd3118vs",
    authDomain: "static-concept-278914.firebaseapp.com",
    databaseURL: "https://static-concept-278914.firebaseio.com",
    projectId: "static-concept-278914",
    storageBucket: "static-concept-278914.appspot.com",
    messagingSenderId: "795047484553",
    appId: "1:795047484553:web:8f336fa0b43bfeb55afa58"
};